// helpers/userFormMapper.js

const mapUserToForm = (user) => {

    return {
        _id: user._id,

        // básicos
        email: user.email,
        rol: user.rol,

        // personales
        firstname: user.personal?.firstname || '',
        lastname: user.personal?.lastname || '',
        personalEmail: user.personal?.emails?.personal || '',
        nacionality: user.personal?.nationality || '',
        dni: user.personal?.identification || '',
        identificationType: user.personal?.identificationType || '',
        nationality: user.personal?.nationality || '',
        civilStatus: user.personal?.civilStatus || '',
        gender: user.personal?.gender || '',
        birthday: user.personal?.birthday
            ? user.personal.birthday.split('T')[0]
            : '',

        phone: user.personal?.phones?.personal || '',
        phoneWork: user.personal?.phones?.work || '',
        emergencyPhone: user.personal?.phones?.emergency || '',

        // dirección
        address: user.address?.address || '',
        postalCode: user.address?.postalCode || '',
        town: user.address?.town || '',
        province: user.address?.province || '',
        country: user.address?.country || '',

        // laboral
        department: user.work?.department || '',
        workcenter: user.work?.workcenter || '',
        vacationApprover: user.work?.approvers?.vacation || '',
        timeTrackingApprover: user.work?.approvers?.timeTracking || '',
        studyLevel: user.work?.studyLevel || '',
        professionalCategory: user.work?.professionalCategory || '',
        contractCode: user.work?.contractCode || '',
        contributionGroup: user.work?.contributionGroup || '',
        socialSecurityNumber: user.work?.socialSecurityNumber || '',
        salaryRange: user.work?.salary?.range || '',

        // banco
        accountHolder: user.bank?.accountHolder || '',
        iban: user.bank?.iban || '',
        swift: user.bank?.swift || '',
        bank: user.bank?.entity || '',

        // training
        officialEducation: user.training?.officialEducation || '',
        additionalTraining: user.training?.additionalTraining || '',
        languages: user.training?.languages || '',
        skills: user.training?.skills || '',

        // accesos
        NFCAccess: user.access?.nfc || '',

        // config
        language: user.config?.language || '',

        // apps
        apps: {
            odoo: user.apps?.odoo || false,
            sesamehr: user.apps?.sesamehr || false,
            iseazy: user.apps?.iseazy || false
        }
    }
}

export default mapUserToForm